import { Link } from '@mui/joy';
import { createFileRoute } from '@tanstack/react-router';

import { ContainerLayout } from '@/components/ContainerLayout';
import { LegalHeading } from '@/components/legal/LegalHeading';
import { LegalText } from '@/components/legal/LegalText';

function AccessibilityRoute() {
  return (
    <ContainerLayout>
      <LegalHeading level="h1">Barrierefreiheitserklärung</LegalHeading>

      <LegalHeading>Einleitung</LegalHeading>
      <LegalText>
        Das Ministerium für Verkehr Baden-Württemberg ist bemüht, seine Web-Anwendungen und mobilen Anwendungen im
        Einklang mit § 12a des Landesbehindertengleichstellungsgesetzes (L-BGG) und der
        Barrierefreie-Informationstechnik-Verordnung (BITV 2.0) barrierefrei zugänglich zu machen.
      </LegalText>

      <LegalHeading>Stand der Vereinbarkeit mit den Anforderungen</LegalHeading>
      <LegalText>
        Diese Web-Anwendung ist teilweise mit § 12a L-BGG und der BITV 2.0 vereinbar. Einige Inhalte entsprechen noch
        nicht vollständig den Anforderungen.
      </LegalText>

      <LegalHeading>Nicht barrierefreie Inhalte</LegalHeading>
      <LegalText>Die nachstehend aufgeführten Inhalte sind aus den folgenden Gründen nicht barrierefrei:</LegalText>
      <ul>
        <li>
          <b>Unvereinbarkeit mit § 12a L-BGG und der BITV 2.0:</b>
          <ul>
            <li>Einige Bilder und Grafiken verfügen noch nicht über alternative Texte.</li>
            <li>Eingabeformulare fehlen teilweise noch beschreibende Labels.</li>
            <li>Kontrast- und Farbverhältnisse in der Kartenanwendung</li>
            <li>Bildschirmskalierung wurde initial auf das Zielformat Full-HD und 100% festgelegt</li>
            <li>Keine durchgängige Tastaturbedienbarkeit</li>
          </ul>
        </li>
        <li>
          <b>Unverhältnismäßige Belastung::</b>
          <ul>
            <li>
              Eine vollständige Barrierefreiheit aller Dokumente und Multimedia-Inhalte kann aktuell aufgrund des hohen
              Aufwandes und der begrenzten Ressourcen nicht gewährleistet werden.
            </li>
          </ul>
        </li>
      </ul>

      <LegalHeading>Erstellung dieser Erklärung zur Barrierefreiheit</LegalHeading>
      <LegalText>
        Diese Erklärung wurde am 11.06.2024 erstellt und beruht auf einer durchgeführten Selbstbewertung. Die Erklärung
        wurde zuletzt am 04.12.2025 überprüft.
      </LegalText>

      <LegalHeading>Feedback und Kontaktangaben</LegalHeading>
      <LegalText>
        Sind Ihnen Mängel beim barrierefreien Zugang zu Inhalten unserer Website aufgefallen? Dann können Sie sich gerne
        bei uns melden.
      </LegalText>

      <LegalText>
        <br />
        <b>Ministerium für Verkehr Baden-Württemberg</b>
        <br />
        Dorotheenstraße 8<br />
        70173 Stuttgart
        <br />
        Telefon: +49 711 89686-9100
        <br />
        E-Mail: <Link href="mailto:presse@vm.bwl.de">presse@vm.bwl.de</Link>
      </LegalText>

      <LegalHeading>Durchsetzungsverfahren</LegalHeading>
      <LegalText>
        Falls auch nach Ihrem Feedback an den oben genannten Kontakt keine zufriedenstellende Lösung gefunden wurde,
        können Sie sich an die Landes-Behindertenbeauftragte wenden.
      </LegalText>

      <LegalText>
        <br />
        <b>Landes-Behindertenbeauftragte</b>
        <br />
        Simone Fischer
        <br />
        Else-Josenhans-Straße 6<br />
        70173 Stuttgart
        <br />
        Telefon: +49 711 279-3360
        <br />
        E-Mail: <a href="mailto:poststelle@bfbmb.bwl.de">poststelle@bfbmb.bwl.de</a>
      </LegalText>

      <LegalText>
        <br />
        Wenn Sie der Meinung sind, dass diese Webseite nicht barrierefrei zugänglich ist, können Sie unsere in Ziffer 4
        genannte Stelle oder Person darüber informieren.
      </LegalText>

      <LegalText>
        <br />
        Falls wir Ihnen nicht oder nicht zufriedenstellend innerhalb von vier Wochen ab Zugang Ihrer Anfrage antworten,
        können Sie sich an die Schlichtungsstelle des Landeszentrums für Barrierefreiheit (LZ-BARR) wenden. Die
        Schlichtungsstelle erreichen Sie wie folgt:
      </LegalText>

      <LegalText>
        <br />
        <b>Landeszentrum Barrierefreiheit</b>
        <br />
        Schlichtungsstelle
        <br />
        Else-Josenhans-Straße 6<br />
        70173 Stuttgart
        <br />
        Telefon: +49 711 123 39375
        <br />
        E-Mail: <a href="mailto:schlichtung@barrierefreiheit.bwl.de">schlichtung@barrierefreiheit.bwl.de</a> <br />
        Webseite: <a href="https://barrierefreiheit-bw.de/">barrierefreiheit-bw.de</a>
      </LegalText>

      <LegalText>
        <br />
        Das Schlichtungsverfahren ist unentgeltlich.
      </LegalText>
      <br />
      <LegalText>
        Wir sind stets bemüht, die Barrierefreiheit unserer Website zu verbessern und freuen uns über Ihre Anmerkungen
        und Hinweise.
      </LegalText>
    </ContainerLayout>
  );
}

export const Route = createFileRoute('/_authenticated/barrierefreiheit')({
  component: AccessibilityRoute,
});
